module.exports = __webpack_public_path__ + "assets/img/logo.2650df3f.png";